import Image from "next/image";
import Link from "next/link";

const footerLinks = [
  {
    heading: "บริการ",
    items: [
      { label: "บัญชีและภาษี", href: "/services/accounting" },
      { label: "จดทะเบียนธุรกิจ", href: "/services/registration" },
      { label: "ค่าบริการ", href: "/pricing" },
      { label: "เกี่ยวกับ KMCP", href: "/about" },
      { label: "บทความ", href: "/blog" }
    ]
  }
];

export default function Footer() {
  return (
    <footer className="border-t border-[#ecdc89] bg-[#fff9dc] text-slate-700">
      <div className="mx-auto flex max-w-7xl flex-col gap-12 px-6 py-16 sm:px-8 sm:py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
          <div className="flex flex-col gap-6 md:col-span-1 md:pr-6">
            <div className="flex items-center gap-4">
              <Image
                src="/KMCPwithtagline-rebg.png"
                alt="KMCP Accounting"
                width={240}
                height={70}
                className="h-16 w-auto"
                sizes="(min-width: 768px) 240px, 200px"
                quality={90}
              />
            </div>
            <div className="space-y-4 text-left">
              <p className="text-base font-semibold leading-relaxed text-gray-950">Partner in Accounting & Tax</p>
              <p className="text-sm leading-relaxed text-slate-600">บริการบัญชี ภาษี และจดทะเบียนธุรกิจในเชียงใหม่</p>
              <div className="flex items-center gap-4 text-slate-600">
                <a
                  href="https://www.facebook.com/kmcp.acc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="-ml-2 rounded-full p-2 transition hover:text-gray-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950"
                  aria-label="KMCP Facebook"
                >
                  <svg className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M22 12.07C22 6.51 17.52 2 12 2S2 6.51 2 12.07C2 17.1 5.66 21.24 10.44 22v-6.99H7.9v-2.94h2.54V9.83c0-2.5 1.5-3.88 3.78-3.88 1.1 0 2.24.2 2.24.2v2.48h-1.26c-1.24 0-1.62.77-1.62 1.56v1.87h2.76l-.44 2.94h-2.32V22C18.34 21.24 22 17.1 22 12.07Z" />
                  </svg>
                </a>
                <a
                  href="https://line.me/R/ti/p/@kmcp.acc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded-full p-2 transition hover:text-gray-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950"
                  aria-label="KMCP LINE Official"
                >
                  <svg className="h-6 w-6" viewBox="0 0 48 48" fill="currentColor" aria-hidden="true">
                    <path d="M12.5,42h23c3.59,0,6.5-2.91,6.5-6.5v-23C42,8.91,39.09,6,35.5,6h-23C8.91,6,6,8.91,6,12.5v23C6,39.09,8.91,42,12.5,42z"></path><path fill="#fff" d="M37.113,22.417c0-5.865-5.88-10.637-13.107-10.637s-13.108,4.772-13.108,10.637c0,5.258,4.663,9.662,10.962,10.495c0.427,0.092,1.008,0.282,1.155,0.646c0.132,0.331,0.086,0.85,0.042,1.185c0,0-0.153,0.925-0.187,1.122c-0.057,0.331-0.263,1.296,1.135,0.707c1.399-0.589,7.548-4.445,10.298-7.611h-0.001C36.203,26.879,37.113,24.764,37.113,22.417z M18.875,25.907h-2.604c-0.379,0-0.687-0.308-0.687-0.688V20.01c0-0.379,0.308-0.687,0.687-0.687c0.379,0,0.687,0.308,0.687,0.687v4.521h1.917c0.379,0,0.687,0.308,0.687,0.687C19.562,25.598,19.254,25.907,18.875,25.907z M21.568,25.219c0,0.379-0.308,0.688-0.687,0.688s-0.687-0.308-0.687-0.688V20.01c0-0.379,0.308-0.687,0.687-0.687s0.687,0.308,0.687,0.687V25.219z M27.838,25.219c0,0.297-0.188,0.559-0.47,0.652c-0.071,0.024-0.145,0.036-0.218,0.036c-0.215,0-0.42-0.103-0.549-0.275l-2.669-3.635v3.222c0,0.379-0.308,0.688-0.688,0.688c-0.379,0-0.688-0.308-0.688-0.688V20.01c0-0.296,0.189-0.558,0.47-0.652c0.071-0.024,0.144-0.035,0.218-0.035c0.214,0,0.42,0.103,0.549,0.275l2.67,3.635V20.01c0-0.379,0.309-0.687,0.688-0.687c0.379,0,0.687,0.308,0.687,0.687V25.219z M32.052,21.927c0.379,0,0.688,0.308,0.688,0.688c0,0.379-0.308,0.687-0.688,0.687h-1.917v1.23h1.917c0.379,0,0.688,0.308,0.688,0.687c0,0.379-0.309,0.688-0.688,0.688h-2.604c-0.378,0-0.687-0.308-0.687-0.688v-2.603c0-0.001,0-0.001,0-0.001c0,0,0-0.001,0-0.001v-2.601c0-0.001,0-0.001,0-0.002c0-0.379,0.308-0.687,0.687-0.687h2.604c0.379,0,0.688,0.308,0.688,0.687s-0.308,0.687-0.688,0.687h-1.917v1.23H32.052z"></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          {footerLinks.map((column) => (
            <div key={column.heading} className="flex flex-col gap-4 md:col-span-1 md:pl-8 lg:pl-16">
              <p className="text-base font-semibold text-gray-950">
                {column.heading}
              </p>
              <ul className="space-y-2 text-sm text-slate-600">
                {column.items.map((item) => (
                  <li key={item.label}>
                    <Link className="transition hover:text-gray-950" href={item.href}>
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div className="flex flex-col gap-4 md:col-span-1 md:pl-6">
            <p className="text-base font-semibold text-gray-950">ติดต่อเรา</p>
            <div className="space-y-3 text-sm text-slate-600">
              <p>
                โทร.{" "}
                <a href="tel:0822546831" className="text-gray-950 transition hover:text-[#8b6d00]">
                  082-254-6831
                </a>
              </p>
              <p>
                LINE Official:{" "}
                <a href="https://line.me/R/ti/p/@kmcp.acc" target="_blank" rel="noreferrer" className="text-gray-950 transition hover:text-[#8b6d00]">
                  @kmcp.acc
                </a>
              </p>
              <p>
                อีเมล{" "}
                <a href="mailto:kmcp.acc@gmail.com" className="text-gray-950 transition hover:text-[#8b6d00]">
                  kmcp.acc@gmail.com
                </a>
              </p>
              <p className="max-w-xs leading-7">
                120/36 หมู่ 3 ตำบลดอนแก้ว อำเภอแม่ริม จังหวัดเชียงใหม่ 50180
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-between gap-4 border-t border-[#eadb91] pt-8 text-sm text-slate-500 sm:flex-row">
          <p>© {new Date().getFullYear()} KMCP Accounting. สงวนลิขสิทธิ์</p>
          <div className="flex gap-6">
            <Link href="/privacy" className="transition hover:text-gray-950">
              นโยบายความเป็นส่วนตัว
            </Link>
            <Link href="/terms" className="transition hover:text-gray-950">
              เงื่อนไขการให้บริการ
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
